import { useMemo } from 'react';
import { Button } from '@mui/material';
import { useUserPermissions } from 'src/use-cases/user/useUserPermissions';
import IconExport from 'src/assets/images/icons/export.svg';
import { featureFlags } from 'src/config/featureFlags';
import { useUploadUI } from './useUploadUI';

export const UploadeButtonAction = ({ id }: { id?: string }) => {
  const { data } = useUserPermissions();
  const { isShowUpload, onSetupUpload } = useUploadUI();

  const canUpload: boolean = useMemo(() => {
    if (data?.data && data?.data?.length > 0 && data?.data?.find((item) => item === 'CAN_UPLOAD_INVOICE_FILE')) {
      return true;
    }
    if (featureFlags.UCT && !featureFlags.UCT_PROCUREMENT) {
      return true;
    }
    return false;
  }, [data]);

  return (
    <div className='pr-24 flex items-center gap-16'>
      {canUpload && (
        <Button
          id={id}
          variant='contained'
          onClick={() => onSetupUpload()}
          disabled={isShowUpload}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: '#BFBFBF',
              color: '#FFFFFF',
              cursor: 'not-allowed',
              opacity: 0.9,
            },
          }}
        >
          <div className='flex items-center gap-12'>
            <span className='capitalize text-12 xl:text-14'>Upload New Invoices</span>
            <img src={IconExport} alt='' />
          </div>
        </Button>
      )}
    </div>
  );
};
